import { render, staticRenderFns } from "./orglist.vue?vue&type=template&id=65abbd8e&scoped=true&"
import script from "./orglist.vue?vue&type=script&lang=js&"
export * from "./orglist.vue?vue&type=script&lang=js&"
import style0 from "./orglist.vue?vue&type=style&index=0&id=65abbd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abbd8e",
  null
  
)

export default component.exports